const state = {
    isSaasUser: false,
    hasSaasContract: false,
    certificationPending: false,
    canCreateNew: false,
    hasSaasEvents: false,
    contractManagers: [],
    loaded: false
}

export const getters = {
    isSaasUser: state => state.isSaasUser,
    hasSaasContract: state => state.hasSaasContract,
    certificationPending: state => state.certificationPending,
    canCreateNew: state => state.canCreateNew,
    hasSaasEvents: state => state.hasSaasEvents,
    contractManagers: state => state.contractManagers,
    loaded: state => state.loaded,
    hasActionRequired: state => state.certificationPending,
    hasRegion: state => regionId => state.contractManagers.some(cm => cm.region && String(cm.region.id) === String(regionId)),
}

export const mutations = {
    setStatus(state, data) {
        state.isSaasUser = data.is_saas_user || false
        state.hasSaasContract = data.has_saas_contract || false
        state.certificationPending = data.certification_pending || false
        state.canCreateNew = data.can_create_new || false
        state.hasSaasEvents = data.has_saas_events || false
        state.contractManagers = data.contract_managers || []
        state.loaded = true
    },
    resetStatus(state) {
        state.isSaasUser = false
        state.hasSaasContract = false
        state.certificationPending = false
        state.canCreateNew = false
        state.hasSaasEvents = false
        state.contractManagers = []
        state.loaded = false
    }
}

export const actions = service => ({
    async fetchStatus({commit}) {
        const data = await service.fetchStatus()
        commit('setStatus', data)
    }
})

export default service => ({
    namespaced: true,
    state,
    getters,
    mutations,
    actions: actions(service)
})
